var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1451 27.5709L23.9149 37.3406C32.0063 35.1829 38 27.8107 38 18.9999C38 18.8201 38 18.6403 38 18.4605L30.3281 11.3879L14.1451 27.5709Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4795 23.2556C20.3186 24.0947 20.3186 25.5332 19.4795 26.3723L17.7413 28.1105C16.9022 28.9496 15.4637 28.9496 14.6246 28.1105L7.01264 20.4386C6.17352 19.5995 6.17352 18.161 7.01264 17.3219L8.75081 15.5837C9.58993 14.7446 11.0284 14.7446 11.8675 15.5837L19.4795 23.2556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1325 10.0095C26.9716 9.17035 28.4101 9.17035 29.2492 10.0095L30.9874 11.7476C31.8265 12.5868 31.8265 14.0252 30.9874 14.8644L17.8012 27.9905C16.9621 28.8297 15.5236 28.8297 14.6845 27.9905L12.9464 26.2524C12.1072 25.4132 12.1072 23.9748 12.9464 23.1356L26.1325 10.0095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.c67a11b6118072ad5cad98e5020ae0a2.svg";
export { ForwardRef as ReactComponent };